module.exports = __webpack_public_path__ + "img/constellations-art.e06e5f59.png";